import { Position } from 'geojson';
import { useReducer } from 'react';

import { NullableCoordinates } from '@/types/commons/commons.types';

interface State {
  isMeasureActive: boolean;
  isClickEnabled: boolean;
  mousePosition: NullableCoordinates | null;
  measurePoints: Position[];
}

type Action =
  | { type: 'SET_IS_MEASURE_ACTIVE'; payload: boolean }
  | { type: 'SET_IS_CLICK_ENABLED'; payload: boolean }
  | { type: 'SET_MOUSE_POSITION'; payload: NullableCoordinates | null }
  | { type: 'SET_MEASURE_POINTS'; payload: Position[] };

const initialState: State = {
  isMeasureActive: false,
  isClickEnabled: false,
  mousePosition: null,
  measurePoints: [],
};

function measureReducer(state: State, action: Action): State {
  switch (action.type) {
    case 'SET_IS_MEASURE_ACTIVE':
      return { ...state, isMeasureActive: action.payload };
    case 'SET_IS_CLICK_ENABLED':
      return { ...state, isClickEnabled: action.payload };
    case 'SET_MOUSE_POSITION':
      return { ...state, mousePosition: action.payload };
    case 'SET_MEASURE_POINTS':
      return { ...state, measurePoints: action.payload };
    default:
      return state;
  }
}

export const useMapMeasureState = () => {
  const [state, dispatch] = useReducer(measureReducer, initialState);

  const setIsMeasureActive = (isMeasureActive: boolean) => {
    dispatch({ type: 'SET_IS_MEASURE_ACTIVE', payload: isMeasureActive });
  };

  const setIsClickEnabled = (isClickEnabled: boolean) => {
    dispatch({ type: 'SET_IS_CLICK_ENABLED', payload: isClickEnabled });
  };
  const setMousePosition = (position: NullableCoordinates | null) => {
    dispatch({ type: 'SET_MOUSE_POSITION', payload: position });
  };

  const setMeasurePoints = (points: Position[]) => {
    dispatch({ type: 'SET_MEASURE_POINTS', payload: points });
  };

  return {
    state,
    setIsMeasureActive,
    setIsClickEnabled,
    setMousePosition,
    setMeasurePoints,
  };
};
